/**
 * Created by hao.cheng on 2017/4/28.
 */
import Cookies from 'js-cookie';
import moment from "moment";
// 深拷贝多层的数组对象
export const handleDeepCopy = (value) => {
    if (Array.isArray(value)) {
        value = value.slice();
        value = value.map(item => handleDeepCopy(item))
    } else if (typeof value === 'object') {
        value = Object.assign({}, value);
        for (let key in value) {
            value[key] = handleDeepCopy(value[key])
        }
    }
    return value
}

// 写入导出/导入需要的数据权限
export const handleExportParams = () => {
    let loginData = Cookies.get('loginData');
    if (loginData) {
        loginData = JSON.parse(loginData);
        let exportsParams = { token: loginData.loginToken,phone: loginData.phone, isJr: loginData.isJr,isDevice: loginData.isDevice };
        if (loginData.merchantId) {
            exportsParams.merchantId = loginData.merchantId;
            exportsParams.merchantUserId = loginData.id;
            exportsParams.merchantUserName=encodeURIComponent(loginData.name);
        } else {
            exportsParams.employeeId = loginData.id;
        }
        return exportsParams
    };
    return {}
}

// 判断是否是平台
export  const isPlatform=() =>{

    if(handleExportParams().merchantId && handleExportParams().merchantId > 0){
        return false;
    }

    return true;

}

export const  digitUppercase =(n) => {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '负' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (let i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
}


export  const floatObj=() => {

    /*
     * 判断obj是否为一个整数
     */
    function isInteger(obj) {
        return Math.floor(obj) === obj
    }

    /*
     * 将一个浮点数转成整数，返回整数和倍数。如 3.14 >> 314，倍数是 100
     * @param floatNum {number} 小数
     * @return {object}
     *   {times:100, num: 314}
     */
    function toInteger(floatNum) {
        var ret = {times: 1, num: 0};
        if (isInteger(floatNum)) {
            ret.num = floatNum;
            return ret
        }
        var strfi = floatNum + '';
        var dotPos = strfi.indexOf('.');
        var len = strfi.substr(dotPos + 1).length;
        var times = Math.pow(10, len);
        var intNum = parseInt(floatNum * times + 0.5, 10);
        ret.times = times;
        ret.num = intNum;
        return ret
    }

    /*
     * 核心方法，实现加减乘除运算，确保不丢失精度
     * 思路：把小数放大为整数（乘），进行算术运算，再缩小为小数（除）
     *
     * @param a {number} 运算数1
     * @param b {number} 运算数2
     * @param op {string} 运算类型，有加减乘除（add/subtract/multiply/divide）
     *
     */
    function operation(a, b, op) {
        var o1 = toInteger(a);
        var o2 = toInteger(b);
        var n1 = o1.num;
        var n2 = o2.num;
        var t1 = o1.times;
        var t2 = o2.times;
        var max = t1 > t2 ? t1 : t2;
        var result = null;
        switch (op) {
            case 'add':
                if (t1 === t2) { // 两个小数位数相同
                    result = n1 + n2
                } else if (t1 > t2) { // o1 小数位 大于 o2
                    result = n1 + n2 * (t1 / t2)
                } else { // o1 小数位 小于 o2
                    result = n1 * (t2 / t1) + n2
                }
                return result / max;
            case 'subtract':
                if (t1 === t2) {
                    result = n1 - n2
                } else if (t1 > t2) {
                    result = n1 - n2 * (t1 / t2)
                } else {
                    result = n1 * (t2 / t1) - n2
                }
                return result / max;
            case 'multiply':
                result = (n1 * n2) / (t1 * t2);
                return result;
            case 'divide':
                result = (n1 / n2) * (t2 / t1);
                return result
            default:
                return ''
        }
    }

    // 加减乘除的四个接口
    function add(a, b) {
        return operation(a, b, 'add')
    }

    function subtract(a, b) {
        return operation(a, b, 'subtract')
    }

    function multiply(a, b) {
        return operation(a, b, 'multiply')
    }

    function divide(a, b) {
        return operation(a, b, 'divide')
    }

    // exports
    return {
        add: add,
        subtract: subtract,
        multiply: multiply,
        divide: divide
    }
};



// 金额千位加逗号
export const moneyAddComma = (mny) => {
    if (mny) {
        let disMny = mny.toString().split('.');
        let mnyArr = disMny[0].split('').reverse();
        if (mny < 0) {
            mnyArr = mnyArr.slice(0, -1);
        }
        for (var i = 3; i < mnyArr.length; i += 4) {
            if (i < mnyArr.length) {
                mnyArr.splice(i, 0, ',')
            }
        }
        mnyArr = mnyArr.reverse().join('');
        if (mny < 0) {
            mnyArr = '-' + mnyArr;
        }
        if (disMny[1]) { //小数点后面补0
            if (disMny[1].length === 1) {
                disMny[1] = disMny[1] + '0';
            } else {
                disMny[1] = Number('0.' + disMny[1]).toFixed(2).slice(2);
            }
        } else {
            disMny[1] = '00';
        }
        return mnyArr + (disMny[1] ? `.${disMny[1].slice(0, 2)}` : '')
    }
    return '0.00'
}

// 获取url的参数
export const queryString = () => {
    let _queryString = {};
    const _query = window.location.search.substr(1);
    const _vars = _query.split('&');
    _vars.forEach((v, i) => {
        const _pair = v.split('=');
        if (!_queryString.hasOwnProperty(_pair[0])) {
            _queryString[_pair[0]] = decodeURIComponent(_pair[1]);
        } else if (typeof _queryString[_pair[0]] === 'string') {
            const _arr = [_queryString[_pair[0]], decodeURIComponent(_pair[1])];
            _queryString[_pair[0]] = _arr;
        } else {
            _queryString[_pair[0]].push(decodeURIComponent(_pair[1]));
        }
    });
    return _queryString;
};
export const ToParamForObject = (obj) => {
    var entries = Object.entries(obj)
    entries = entries.map(e => e.join("="))
    entries = entries.join('&')
    return entries
}
export const numToType = (e, arr) => {
    var keyObj = { key: 0, name: '', color: '' }
    arr.forEach(v => {
        if (e === v.key) {
            keyObj = v
        }
    })


    return keyObj
}
//格式化时间
export const formatTime = (datetime, format='YYYY-MM-DD HH:mm:ss') => {
    if (typeof(format) !== 'string') {
        format='YYYY-MM-DD HH:mm:ss'
    }
    if (!datetime) return ''
    return moment(datetime).format(format)
}

export const addrFromJson = (addrJson) => {
    const addr = [];
    addrJson.then(addressData => {


        const province = Object.keys(addressData);
        for (let item in province) {
            const key = province[item];
            const cityList = [];
            if (addressData[key].length > 0) {
                for (let item1 in addressData[key]) {
                    const obj = {
                        'value': addressData[key][item1],
                        'label': addressData[key][item1]
                    }
                    cityList.push(obj);
                }
            }
            const obj = {
                'value': key,
                'label': key,
                'children': cityList
            }
            addr.push(obj);
        }

    })
    return addr
}
export const G_formatUpload = (url) => {
    if (url) {
        var _random = Math.random() * 100
        return [{
            url: url,
            uid: _random,
            name: _random + 'Upload.png',
            status: 'done'
        }]
    } else {
        return []
    }
}
export const G_formatField = (res) => {
    let _obj = res || {}

    let _done = {}
    for (let key in _obj) {
        _done[key] = { value: _obj[key] }
    }
    return _done
}
export const G_mergeObject = (mainArr, datas) => {
    mainArr.forEach(e => {
        for (let key in datas) {
            if (e.key === key) {
                e.value = datas[key]
            }
        }
    })
    return mainArr
}
/**
 * 数组去重
 *
 * @param {any} [arr=[]] 需要处理的数组
 * @returns 去重后的数组
 */
export const ArrayUnique = (arr = []) => {
    var set = new Set(arr)
    return Array.from(set)
}
/**
 * 取出数组中的对象的某个key值的集合
 *
 * @param {Array} [arr=[]] 需要处理的数组
 * @param {String} key 要取得Key
 * @returns {Array} Key值的集合
 */
export const GetKeyFromArray = (arr = [], key) => {
    const _arr = arr.map(v => {
        return v[key]
    })
    return _arr
}

export const ArrayDiff = (arr1, arr2) => {
    return arr1.filter(key => !arr2.includes(key))
}

export const isDev = () => {
    let url = window.location.href
    let dev = url.indexOf('localhost') > -1 || url.indexOf('192.168') > -1 || url.indexOf('127') > -1
    return dev
}

export function G_findIndex(arr, item_key, param) {
    let done = null
    arr.forEach(function (e, i) {
        if (e[item_key] === param) {
            done = i
        }
    })
    return done
}

export function findDict(dict = [], value) {
    return dict.find(e => e.value === value) || {}
}

/**
 * @param {string} url
 * @returns {Object}
 */
 export function params2Object(url) {
    const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
    if (!search) {
      return {}
    }
    const obj = {}
    const searchArr = search.split('&')
    searchArr.forEach(v => {
      const index = v.indexOf('=')
      if (index !== -1) {
        const name = v.substring(0, index)
        const val = v.substring(index + 1, v.length)
        obj[name] = val
      }
    })
    return obj
  }


// WEBPACK FOOTER //
// ./src/utils/index.jsx